import { berlinDatum } from "@dj/domain/gemeinsam";
import { Navigate, useParams } from "react-router";
import { useSammlung } from "../plattform/lesemodelle";
import { useSitzung } from "../plattform/sitzung";
import { serverJetzt } from "./serverzeit";

/** Arten mit einem Ziel in der Drückjagd: Unterpfad der Ansicht (leer = Startansicht), für die Leitung ggf. ein eigenes. */
const ZIEL: Record<string, { alle: string; leitung?: string }> = {
  "Hahn-in-Ruh": { alle: "" }, "Jagd-im-Gange": { alle: "" }, "Jagdzeitplan-geaendert": { alle: "" },
  Notruf: { alle: "", leitung: "lagebild" }, "Hund-vermisst": { alle: "", leitung: "lagebild" }, "Hund-gesichtet": { alle: "" },
  "Hund-zurueck": { alle: "" }, "Stand-erreicht": { alle: "abholliste" }, "Position-weicht-vom-Stand-ab": { alle: "" },
  Wildfolge: { alle: "", leitung: "offene-suchen" },
};

/**
 * Geöffnete Benachrichtigung (benachrichtigungen.md §3, LIM-0021): Der Link trägt nur die Art, nie eine Kennung. Für
 * Benachrichtigungen einer Drückjagd zeigt die App die passende Ansicht der Drückjagd von heute (sonst der nächsten),
 * aus „Meine Drückjagden“: den Jagdzustand auf der Startansicht, einen Notruf der Leitung im Lagebild (oberflaeche.md
 * §8 Nr. 7), „Stand erreicht“ dem Ansteller in der Abholliste, „Wildfolge“ der Leitung in Offene Suchen (Region
 * „Wildfolge“); alles andere führt zu „Meine Drückjagden“ (dort auch die Einladungen zu gemeinsamen Drückjagden).
 */
export function BenachrichtigungOeffnen() {
  const { "*": art = "" } = useParams();
  const { uid } = useSitzung();
  const ziel = ZIEL[art];
  const liste = useSammlung(uid && ziel ? `personen/${uid}/meine_drueckjagden` : null);
  if (!ziel) return <Navigate to="/" replace />;
  if (liste.laedt) return <div className="ansicht ansicht--neutral" aria-busy="true" />;
  const heute = berlinDatum(serverJetzt());
  const datum = (d: Record<string, unknown>) => String(d["Jagddatum"] ?? "");
  const kandidaten = [...liste.daten].sort((a, b) => datum(a).localeCompare(datum(b)));
  const dj = kandidaten.find((d) => datum(d) === heute) ?? kandidaten.find((d) => datum(d) > heute) ?? kandidaten[kandidaten.length - 1];
  if (!dj) return <Navigate to="/" replace />;
  const rollen = (dj["Rollen"] as string[] | undefined) ?? [];
  const leitung = rollen.includes("Jagdherr") || rollen.includes("Jagdleiter");
  const teil = leitung && ziel.leitung !== undefined ? ziel.leitung : ziel.alle;
  return <Navigate to={`/drueckjagd/${dj._id}${teil ? `/${teil}` : ""}`} replace />;
}
